import React, { useContext, Fragment } from 'react'
import { Typography } from '@material-ui/core'
import DatePickerRange from '../../../components/filters/DatePickerRange'
import { FactoryFiltersContext } from '../../../context/FactoryFiltersContext'
import moment from 'moment'
import { defaultFormatTimeZone } from '../../../utils/consts'

export default function DateRange (): JSX.Element {
  const { filters, setFilters } = useContext(FactoryFiltersContext)
  const onChange = (initialDate: moment.Moment, finalDate: moment.Moment) => {
    setFilters({
      orderCreatedAt: {
        initialDate: initialDate.format('YYYY-MM-DD'),
        finalDate: finalDate.format('YYYY-MM-DD'),
        ...defaultFormatTimeZone
      }
    })
  }

  return (
    <Fragment>
      <Typography id="discrete-slider-custom" gutterBottom>Período</Typography>
      <DatePickerRange
        defaultInitialValue={moment(filters.orderCreatedAt?.initialDate)}
        defaultFinalValue={moment(filters.orderCreatedAt?.finalDate)}
        onChange={onChange}
      />
    </Fragment>
  )
}
